import useEquipmentEnabled from 'hooks/settings/useEquipmentEnabled/useEquipmentEnabled';
import { useFeatureFlags } from 'utils/features';

export default function useIntegratedEquipmentEnabled() {
  const gpsHardwareEnabled = useFeatureFlags('EQUIPMENT_GPS_HARDWARE');

  const equipmentEnabled = useEquipmentEnabled();

  return gpsHardwareEnabled && equipmentEnabled;
}
